import { makeApiCall } from '../core';
import type { ConversationSummary, ItemEnvelope } from '@ruta/shared';

// =====================
// Conversations API
// =====================

export interface GetConversationsResponse {
  conversations: ConversationSummary[];
  nextToken?: string;
  hasMore: boolean;
  totalUnread: number;
}

export interface ConversationFilters {
  unreadOnly?: boolean;
  needsResponse?: boolean;
}

export const getConversations = async (options?: {
  limit?: number;
  nextToken?: string;
} & ConversationFilters): Promise<GetConversationsResponse> => {
  const params = new URLSearchParams();
  if (options?.limit) params.append('limit', options.limit.toString());
  if (options?.nextToken) params.append('nextToken', options.nextToken);
  if (options?.unreadOnly) params.append('unreadOnly', 'true');
  if (options?.needsResponse) params.append('needsResponse', 'true');

  const queryString = params.toString();
  const response = await makeApiCall<ItemEnvelope<GetConversationsResponse>>(
    'GET',
    `/message-threads${queryString ? `?${queryString}` : ''}`,
  );
  return response.data;
};
